module.exports = __webpack_public_path__ + "static/media/fb-content-loader.fade6616.gif";